<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_STT')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectEmailRecpStatus"
              v-model="searchData.searchEmailRecpStatus"
              codeId="COD_EMAIL_RECP_STT"
              :defaultOption="'all'"
              :filteredOptionList="filteredOptionList"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_DIV')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectEmailRecpUsrType"
              v-model="searchData.searchEmailRecpUsrType"
              codeId="COD_EMAIL_RECP_USR_TYPE"
              :defaultOption="'all'"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_TITLE')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldEmailTitle"
              v-model="searchData.searchEmailTitle"
              maxlength="200"
              @keyup.enter="onSearchClick"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_SENDER')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldSendUserEmail"
              v-model="searchData.searchEmailSendUser"
              maxlength="50"
              @keyup.enter="onSearchClick"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_RECEIVE_DATE')"
              :vertical="false"
              :required="true"
            />
          </div>
          <div class="col-xs-5">
            <sui-range-date-picker
              ref="dp"
              v-model="searchData.rangeDate"
              :value="searchData.rangeDate"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onResetClick"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onSearchClick"
          >
            {{ $t("MSG_BTN_SRCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="gridEmail"
        :columns="columnEmail"
        :dataset="'dsEmail'"
        :showDisplayCountControl="true"
        :multiselect="true"
        :showCountControl="true"
        :initialPagesize="10"
      >
        <!-- <div class="btn_wrapR">
          <sui-button
            v-permission:download="contextPageId"
            type="button"
            class="comm_btn_gridTop comm_ico_excel"
            @click="onExcelDownloadClick"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </div> -->
      </sui-grid>
      <div class="btn_moreView">
        <p
          :class="pageing.totalCount === 0 || pageing.count === pageing.totalCount ? 'disabled' : ''"
          @click="onAddList"
        >
          {{ $t("MSG_TXT_SHOW_MORE") }} {{ showMoreCount }}
        </p>
      </div>
      <div class="comm_btn_wrap">
        <sui-button
          v-permission:delete="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="onDeleteClick"
        >
          {{ $t('MSG_BTN_DEL') }}
        </sui-button>
        <!-- <sui-button
          v-permission:create="contextPageId"
          type="button"
          class="comm_btn_solid"
          @click="onRegistClick"
        >
          {{ $t('MSG_BTN_NEW_EMAIL') }}
        </sui-button> -->
      </div>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import BasePage from '~cm/components/BasePage';

const dateTypeFields = ['emailStartDTM', 'firstRegistrationDTM', 'finalModificationDTM'];

/* eslint max-len: ["error", { "code" : 500 }] */
export default {
  name: 'PGE_CMM_00001', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  data() {
    return {
      isPageing: false,
      pageing: {
        pagePerCount: 1000,
        currentPage: 1,
        totalCount: 0,
        count: 0,
      },
      filteredOptionList: [
        { key: 'ALL' },
        { key: 'UNOPEN' },
        { key: 'OPEN' },
      ],
      searchData: {
        searchEmailRecpStatus: '',
        searchEmailRecpUsrType: '',
        searchEmailTitle: '',
        searchEmailSendUser: '',
        rangeDate: { from: moment().add(0, 'year').add(-1, 'months').format(), to: moment().add(0, 'year').add(0, 'months').format() },
      },
      // rangeDate: {
      //   from: utils.now('YYYY-MM-DD'),
      //   to: utils.now('YYYY-MM-DD'),
      // },
      mailTitle: this.$t('MSG_TIT_MAIL_SEND'),
      dataParams: {},
      searchEmailType: 'RECEIVE',
      mailStorageBoxId: '',
      mailStorageInfo: {

      },
    };
  },
  computed: {
    showMoreCount() {
      return `(${this.pageing.count}/${this.pageing.totalCount})`;
    },
  },
  watch: {},
  datasets: [{
    id: 'dsEmail',
    type: 'local',
    datafields: [
      {
        name: 'emailUid',
        type: 'string',
        map: 'emailUid',
      },
      {
        name: 'connectionEmailId',
        type: 'string',
        map: 'connectionEmailId',
      },
      {
        name: 'attachDocumentId',
        type: 'string',
        map: 'attachDocumentId',
      },
      {
        name: 'emailTitle',
        type: 'string',
        map: 'emailTitle',
      },
      {
        name: 'sendUserEmail',
        type: 'string',
        map: 'sendUserEmail',
      },
      {
        name: 'emailStartDTM',
        type: 'string',
        map: 'emailStartDTM',
      },
      {
        name: 'emailReceiptUserTypeCode',
        type: 'string',
        map: 'emailReceiptUserTypeCode',
      },
      {
        name: 'emailReceiptUserTypeName',
        type: 'string',
        map: 'emailReceiptUserTypeName',
      },
      {
        name: 'emailReceiptUserIdYn',
        type: 'string',
        map: 'emailReceiptUserIdYn',
      },
      {
        name: 'isTitleBold',
        type: 'string',
        map: 'isTitleBold',
      },
      {
        name: 'sendUserId',
        type: 'string',
        map: 'sendUserId',
      },
      {
        name: 'displayLanguageId',
        type: 'string',
        map: 'displayLanguageId',
      },
      {
        name: 'loginId',
        type: 'string',
        map: 'loginId',
      },
      {
        name: 'knoxId',
        type: 'string',
        map: 'knoxId',
      },
      {
        name: 'userName',
        type: 'string',
        map: 'userName',
      },
      {
        name: 'userGlobalName',
        type: 'string',
        map: 'userGlobalName',
      },
      {
        name: 'departmentName',
        type: 'string',
        map: 'departmentName',
      },
      {
        name: 'departmentEnglishName',
        type: 'string',
        map: 'departmentEnglishName',
      },
    ],
  }],
  created() {
    this.columnEmail = [
      {
        text: 'emailUid',
        datafield: 'emailUid',
        hidden: true,
      },
      {
        text: 'connectionEmailId',
        datafield: 'connectionEmailId',
        hidden: true,
      },
      {
        text: this.$t('MSG_TXT_ATTH_FILE_YN'),
        datafield: 'attachDocumentId',
        width: '50px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellStateButton(row, column, value, htmlElement, {
            useSurfixIcon: false,
            type: 'link',
          }, this.dsEmail, this.$refs.gridEmail);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_TITLE'),
        datafield: 'emailTitle',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellButton(row, column, value, htmlElement, {
            handler: this.onDetailClick,
            type: 'sublink',
            styleBoldFieldName: 'isTitleBold', // ('Y'/'N', true/false)
          }, this.dsEmail, this.$refs.gridEmail);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_SENDER'),
        datafield: 'sendUserEmail',
        width: '300px',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // "1", "2" - default: "1"
            type: 'link', // 'link', 'sublink' - default: "link"
            datafieldMap: {
              displayLanguageId: 'displayLanguageId',
              loginId: 'loginId',
              knoxId: 'knoxId',
              userName: 'userName',
              userGlobalName: 'userGlobalName',
              departmentName: 'departmentName',
              departmentEnglishName: 'departmentEnglishName',
            },
          }, this.dsEmail, this.$refs.gridEmail);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_RECEIVE_DTM'),
        datafield: 'emailStartDTM',
        width: '200px',
      },
      {
        text: this.$t('MSG_TXT_DIV'),
        datafield: 'emailReceiptUserTypeCode',
        width: '100px',
        hidden: true,
      },
      {
        text: this.$t('MSG_TXT_DIV'),
        datafield: 'emailReceiptUserTypeName',
        width: '100px',
      },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.getKeyword().then(() => {
        this.onLoad();
      });
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getKeyword() {
      return new Promise((resolve, reject) => {
        this.mailStorageBoxId = utils.getParameter(this, 'mailBoxId');
        if (!this.mailStorageBoxId) {
          resolve();
        } else {
          http.request(this.contextPageId, 'DTS_CMM_00015', {
            query: {
              mailStorageBoxId: this.mailStorageBoxId,
            },
          }).then(res => {
            this.mailStorageInfo = res.data;
            resolve();
          }).catch(error => {
            console.log(error);
            reject();
          });
        }
      });
    },
    onLoad() {
      const paramData = utils.getParameter(this, 'searchData');
      if (!utils.isEmpty(paramData)) {
        this.searchData = paramData;
        this.onSearchClick();
      } else {
        this.onSearchClick();
      }
    },
    onSearchClick() {
      const sStartDate = this.searchData.rangeDate.from !== null && this.searchData.rangeDate.from !== '' ? utils.dateformatToServer(this.searchData.rangeDate.from) : '';
      const sEndDate = this.searchData.rangeDate.to !== null && this.searchData.rangeDate.to !== '' ? utils.dateformatToServer(this.searchData.rangeDate.to) : '';
      if ((!sStartDate || !sEndDate)) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return false;
      }else if (!this.$refs.dp.isValid()){
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_DT'), null, null);
        return false;
      }

      this.dataParams = {
        searchEmailRecpStatus: this.searchData.searchEmailRecpStatus,
        searchEmailRecpUsrType: this.searchData.searchEmailRecpUsrType,
        searchEmailTitle: this.searchData.searchEmailTitle,
        searchEmailSendUser: this.searchData.searchEmailSendUser,
        searchEmailRecpStartDate: `${utils.toStringByFormat(sStartDate, 'YYYYMMDD')}000000`,
        searchEmailRecpEndDate: sEndDate,
        searchEmailType: 'RECEIVE',
      };

      this.pageing.currentPage = 1;
      this.pageing.totalCount = 0;
      this.pageing.count = 0;

      this.dsEmail.setRawData([]);

      this.searchEmail();
    },
    onAddList() {
      // 더보기
      if (this.isPageing) {
        this.pageing.currentPage += 1;
        this.searchEmail();
      }
    },
    searchEmail() {
      const queryParams = utils.cloneDeep(this.dataParams);

      // pageing
      utils.assign(queryParams, { pagePerCount: this.pageing.pagePerCount });
      utils.assign(queryParams, { currentPage: this.pageing.currentPage });

      // 메일함 키워드 관련 프로퍼티
      utils.assign(queryParams, { mailStorageBoxKeywordValue: this.mailStorageInfo.mailStorageBoxKeywordValue });
      utils.assign(queryParams, { mailMovementYn: this.mailStorageInfo.mailMovementYn });
      utils.assign(queryParams, { prthInclusionYn: this.mailStorageInfo.prthInclusionYn });

      // http.requestTest('get', '/api/v1/common/email', {
      http.request(this.contextPageId, 'DTS_CMM_00001', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, dateTypeFields);

        // 첨부파일
        res.data.forEach(row => {
          const attchDocId = (row.attachDocumentId ? true : false);
          row.attachDocumentId = { text:'', showattach: attchDocId, shownew: false };
        });

        if (utils.isUndefined(res.data) === false && res.data.length === this.pageing.pagePerCount) {
          this.isPageing = true;
        } else {
          this.isPageing = false;
        }

        const union = utils.mergeArray(this.dsEmail.data, res.data);
        this.dsEmail.setRawData(union);

        this.pageing.count = this.dsEmail.data.length;
        if (res.data.length > 0) {
          this.pageing.totalCount = res.data[0].totalCount;
        }
      }).catch(error => {
        console.log(error);
      });
    },
    onResetClick() {
      this.$refs.codeSelectEmailRecpStatus.reset();
      this.$refs.codeSelectEmailRecpUsrType.reset();
      this.searchData.searchEmailTitle = '';
      this.searchData.searchEmailSendUser = '';
      this.searchData.rangeDate = { from: moment().add(0, 'year').add(-1, 'months').format(), to: moment().add(0, 'year').add(0, 'months').format() };
    },
    onRegistClick() {
      utils.openLayerPopup('PGE_CMM_00004', this.onRegistCallback,
        {
          pageInitialData: {
            // mailTitle: this.mailTitle,
            receiverModify: true,
            Editor: 'Y',
            mailSendType: 'N', // N : New
          },
          size: 'xlg',
        });
    },
    onClosePagePopup() {
      this.onSearchClick();
    },
    onDetailClick(btn, selectedRow) {
      if (selectedRow) {
        const attachFileYn = selectedRow.attachDocumentId.showattach === true ? 'Y' : 'N';
        utils.goPage('PGE_CMM_00005', {
          emailUid: selectedRow.emailUid,
          searchData: this.searchData,
          searchEmailType: 'RECEIVE',
          readFlag: 'Y',
          isTitleBold: selectedRow.isTitleBold,
          emailReceiptUserIdYn: selectedRow.emailReceiptUserIdYn,
          attachFileYn,
        });
      }
    },
    onDeleteClick() {
      const selectedIndexes = this.dsEmail.getSelectedIndexes();
      const emailUidList = [];
      if (selectedIndexes.length < 1) {
        utils.messageBox('warning', this.$t('MSG_ALT_DEL_DATA_SELT'));
        return false;
      }
      utils.forEach(selectedIndexes, index => {
        emailUidList.push({
          emailUid: this.dsEmail.data[index].emailUid,
          searchEmailType: 'RECEIVE',
        });
      });
      utils.messageBox('confirm', this.$t('MSG_ALT_WANT_DEL'), null, () => {
        // http.requestTest('delete', `/api/v1/common/email/${emailUid}`, {
        http.request(this.contextPageId, 'DTS_CMM_00002', {
          data: emailUidList,
        }).then(() => {
          utils.messageBox('success', this.$t('MSG_ALT_DELETED'));
          this.onSearchClick();
        });
      });
      return true;
    },
    // onExcelDownloadClick() {
    //   const sPageId = this.contextPageId;
    //   const objGridColumns = this.columnEmail;
    //   const objGridDataset = this.dsEmail;
    //   const sToday = utils.now('YYYYMMDDHHmmss');
    //   const sExcelName = `excel_${sToday}.xlsx`;
    //   utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, {});
    // },
    onGridButtonClicked(btn, dataRow) {
      console.log(btn, dataRow);
      if (this.selectionmode === false) {
        const selectedData = [];
        selectedData[0] = {
          userName: dataRow.userName,
          userGlobalName: dataRow.userGlobalName,
          epid: dataRow.epid,
          siteName: dataRow.siteName,
          employeeIDNumber: dataRow.employeeIDNumber,
          companyName: dataRow.companyName,
          companyEnglishName: dataRow.companyEnglishName,
          departmentName: dataRow.departmentName,
          departmentEnglishName: dataRow.departmentEnglishName,
          careerLevelName: dataRow.careerLevelName,
          careerLevelEnName: dataRow.careerLevelEnName,
          knoxId: dataRow.knoxId,
          servedStateCode: dataRow.servedStateCode,
          userId: dataRow.userId,
          email: dataRow.email,
          dsplLngId: dataRow.dsplLngId,
        };
        this.closePagePopup(selectedData);
      }
    },
    checkEditableFunction() {
      if (this.selectionmode === false) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
</style>
